/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No leagues found" |
*
* @param {League_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_no_results = /** @type {((inputs?: League_No_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_No_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ligue trouvée")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron ligas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma liga encontrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun campionato trovato")
	return /** @type {LocalizedString} */ ("No leagues found")
});